import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Directive({
    selector: '[windowScroll]',
    standalone: true
})
export class WindowScrollDirective {

	@Input() scrollValue: number = 0;

	@Output() windowScroll: EventEmitter<void> = new EventEmitter<void>();

	constructor(private el: ElementRef) {
		el.nativeElement.addEventListener('scroll', () => {
			if (Math.abs(el.nativeElement.clientHeight + el.nativeElement.scrollTop - el.nativeElement.scrollHeight) < 1) {
				this.windowScroll.emit();
			}
		});
	}
}